// Models
import { Filter } from "../client/filter/Filter";
import { TaskStatus } from "../service/planner/enumerations/IPlannerEnumerations";
/**
 * Filter options for the Status filter menu.
 * Includes all real TaskStatus values plus a derived "late" option for client-side late task filtering.
 */ export const StatusFilterOption = {
    NotStarted: TaskStatus.NotStarted,
    InProgress: TaskStatus.InProgress,
    Late: "late",
    Completed: TaskStatus.Completed
};
// Re-export dynamic filter constants (separate file to avoid circular dependency with Filter.ts)
export { DynamicFilterField, NonPersistedFilterFields } from "./DynamicFilterConstants";
/**
 * Task Filter types
 */ export var FilterTypes = /*#__PURE__*/ function(FilterTypes) {
    FilterTypes["DueDateTime"] = "DueDateTime";
    FilterTypes["FinishDateTime"] = "FinishDateTime";
    FilterTypes["Priority"] = "Priority";
    FilterTypes["Status"] = "Status";
    FilterTypes["AppliedCategoryIds"] = "AppliedCategoryIds";
    FilterTypes["BucketId"] = "BucketId";
    FilterTypes["UserAssignments"] = "UserAssignments";
    FilterTypes["PersonalView"] = "PersonalView";
    FilterTypes["GoalIds"] = "GoalIds";
    return FilterTypes;
}({});
/**
 * Maps the Task FilterTypes to the filter field key in ITask
 */ export const FilterFields = {
    DueDateTime: "dueDateTime",
    FinishDateTime: "finishDateTime",
    Priority: "priority",
    Status: "status",
    AppliedCategoryIds: "planView.appliedCategoryIds",
    BucketId: "bucketId",
    UserAssignments: "userAssignments",
    PersonalView: "personalView.isOnMyDay",
    GoalIds: "goalIds"
};
/**
 * Task filter options for Basic Plan
 */ export const BasicPlanFilterOptions = [
    "DueDateTime",
    "FinishDateTime",
    "Priority",
    "Status",
    "BucketId",
    "AppliedCategoryIds",
    "UserAssignments",
    "GoalIds"
];
/**
 * Task filter options for My Tasks
 */ export const MyTasksFilterOptions = [
    "DueDateTime",
    "Priority",
    "Status"
];
/**
 * Task filter options for a todo based plan.
 * Todo plans do not support finish dates (PermissionsStore returns canUpdateFinishDateTime: false
 * for ContainerType.ToDo), so the FinishDate filter is intentionally omitted.
 */ export const TodoPlanFilterOptions = [
    "Priority",
    "Status",
    "PersonalView"
];
/**
 * Default Filters for My Tasks, Basic Plans, Lists
 * By default, the views will not show completed tasks to reduce the amount of data shown upfront
 */ export const DefaultFilter = new Filter("status", [
    TaskStatus.NotStarted,
    TaskStatus.InProgress
]);
